(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'ApplicationContext'];

    function NavbarController($state, Auth, Principal, ProfileService, ApplicationContext) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.isTableManaged = (ApplicationContext.getResourceType() == 'TABLE');
        vm.isProduction = (window.location.href.indexOf("//getseat.net") != -1) || (window.location.href.indexOf("//eu.getseat.net") != -1);

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }


        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            $state.go("account.login");
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('account.login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
